// extracted by mini-css-extract-plugin
module.exports = {"paper":"_3po44eDW","content":"traHZFfg"};